import { render, staticRenderFns } from "./special_plan.vue?vue&type=template&id=019b67fa&scoped=true"
import script from "./special_plan.vue?vue&type=script&lang=js"
export * from "./special_plan.vue?vue&type=script&lang=js"
import style0 from "./special_plan.vue?vue&type=style&index=0&id=019b67fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b67fa",
  null
  
)

export default component.exports